module.exports = __webpack_public_path__ + "img/trainings-icon.4a852952.svg";